
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/rust-web-app-development",
      function () {
        return require("private-next-pages/services/rust-web-app-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/rust-web-app-development"])
      });
    }
  